/**
 * Created by Andste on 2018/5/28.
 * 商品选择器
 * 依赖于element-ui
 */

import Vue from 'vue'
import GaijiaPicker from './src/main.vue'

GaijiaPicker.install = () => {
  Vue.component(GaijiaPicker.name, GaijiaPicker)
}

export default GaijiaPicker
